import React from 'react';
import NextStepsPresentational from './next-step-presentational';

const NextStepFunction = () => {
	return <NextStepsPresentational />;
};
export default NextStepFunction;
